import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import {
    multiSelectedRoiNumbersState,
    multiSelectModeState,
} from '~/state/atoms/structureSet/roiAtoms';

/**
 * Ends selecting several structures: empties the selection and disarms
 * multi-select mode with it. A mode left armed over an empty selection
 * would keep plain clicks toggling checkboxes and keep single-structure
 * tools off, with nothing selected to say why.
 */
export function useClearMultiSelection(): () => void {
    const setMultiSelected = useSetRecoilState(multiSelectedRoiNumbersState);
    const setMultiSelectMode = useSetRecoilState(multiSelectModeState);
    return useCallback(() => {
        setMultiSelected(new Set());
        setMultiSelectMode(false);
    }, [setMultiSelected, setMultiSelectMode]);
}
